import { useIntl } from '@capsicum/common';
import { BaseTextInput as InputText, StandaloneSelectInput as Select } from '@capsicum/common-web';
import { ChevronDownIcon } from '@capsicum/common-web/icons';
import { type AmlQuestionnaireProfessionOption, useAmlProfession } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';

export const Profession = () => {
	const { $t } = useIntl();
	const { handleInput, isOtherSelected, list, onSearch, onSelect } = useAmlProfession();

	const professionItemTemplate = ({ item }: { item: AmlQuestionnaireProfessionOption }) => item.name;

	return (
		<S.Wrapper>
			<S.Question>{$t('amlQuestionnaire.secondStep.question')}</S.Question>
			<Select<AmlQuestionnaireProfessionOption>
				data={list}
				Icon={ChevronDownIcon}
				itemTemplate={professionItemTemplate}
				labelProp="name"
				placeholder={$t('amlQuestionnaire.secondStep.selectPlaceholder')}
				testID="aml-questionnaire-profession-select"
				onChange={onSelect}
				onSearch={onSearch}
			/>
			{isOtherSelected && (
				<InputText
					label={$t('amlQuestionnaire.secondStep.inputLabel')}
					placeholder={$t('amlQuestionnaire.secondStep.inputPlaceholder')}
					testID="aml-questionnaire-profession-other-input-text"
					onChange={e => handleInput(e.target.value)}
				/>
			)}
		</S.Wrapper>
	);
};
